import { Link, useParams } from "react-router-dom";
import { Button, Modal } from "semantic-ui-react";

export function SignUpModal({ onClose, data }: { onClose: () => void; data: { type: "Email" | "Phone" } | null }) {
  const { site } = useParams<{ site: string }>();

  return (
    <Modal open={!!data} onClose={onClose} size='tiny' closeIcon>
      <Modal.Header>Sign Up to Add {data?.type === "Email" ? "Email Address" : "Phone Number"}</Modal.Header>
      <Modal.Content>
        <p>Add multiple contact methods, connect the mobile app, and more with an account.</p>
        <p>
          Already have an account?{" "}
          <Link
            to={{
              pathname: `/${site}/public/login`,
              search: `?redirect=/${site}/public/notify`,
            }}
          >
            Sign In
          </Link>
        </p>
      </Modal.Content>
      <Modal.Actions>
        <Button secondary onClick={onClose}>
          Cancel
        </Button>
        <Button
          primary
          as={Link}
          to={{
            pathname: `/${site}/public/register`,
            search: `?redirect=/${site}/public/notify`,
          }}
        >
          Sign Up
        </Button>
      </Modal.Actions>
    </Modal>
  );
}
